module.exports = __webpack_public_path__ + "img/2022.1.96268df0.jpg";